import React from 'react';

import { Typography } from 'antd';

interface IProps {
  link: string;
}

function FaqLink({ link }: IProps) {
  return (
    <Typography.Text type='secondary'>
      Se tiver dúvidas acesse nosso{' '}
      <Typography.Link strong href={link} target='_blank' rel='noopener noreferrer'>
        FAQ
      </Typography.Link>
    </Typography.Text>
  );
}

export default FaqLink;
